import { Footer, Sidebar } from '../layout';
import React, { Suspense } from 'react';
import Header from './header';
import { IApplicationProps } from '../types/PropTypes';
import PageSpinner from '../components/shared/PageSpinner';
import { Outlet } from 'react-router-dom';

interface IMainLayoutProps extends IApplicationProps {
    breakpoint: string;
}

class MainLayout extends React.Component<IMainLayoutProps> {
    render() {
        return (
            <div className="wrapper">
                <Sidebar location={this.props.location} history={this.props.history} />
                <Header
                    logout={this.props.logout}
                    changeLanguage={this.props.changeLanguage}
                    history={this.props.history}
                />
                <main className="main-content">
                    <div className="container-fluid">
                        <Suspense fallback={<PageSpinner />}>
                            <Outlet />
                        </Suspense>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }
}

export default MainLayout;
